import { render, staticRenderFns } from "./subheaderNavigation.vue?vue&type=template&id=64a5004c"
import script from "./subheaderNavigation.vue?vue&type=script&lang=js"
export * from "./subheaderNavigation.vue?vue&type=script&lang=js"
import style0 from "./subheaderNavigation.vue?vue&type=style&index=0&id=64a5004c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports